/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryProperties } from '../../models/delivery-properties';
import { KeyType } from '../../models/key-type';

export interface PatchConsignorDeliveryNoteProperties$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
      body: DeliveryProperties
}

export function patchConsignorDeliveryNoteProperties(http: HttpClient, rootUrl: string, params: PatchConsignorDeliveryNoteProperties$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchConsignorDeliveryNoteProperties.PATH, 'patch');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

patchConsignorDeliveryNoteProperties.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/properties';
